import { render, staticRenderFns } from "./signDetail.vue?vue&type=template&id=da48112c&scoped=true&"
import script from "./signDetail.vue?vue&type=script&lang=js&"
export * from "./signDetail.vue?vue&type=script&lang=js&"
import style0 from "./signDetail.vue?vue&type=style&index=0&id=da48112c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da48112c",
  null
  
)

export default component.exports